import React, { useEffect, useState } from 'react'
import FetchData from '../../shared/fetchData'
import HeaderForm from '../UI/HeaderForm/HeaderForm'
import ContentForm from '../UI/ContentForm/ContentForm'
import './AboutUs.css'
import Fade from 'react-reveal/Fade'

        const AboutUs = (props) => {
    const [rules, setRules] = useState('')
    useEffect(() => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({"version": "mtpx001"})
        var url = 'api/v1/configurations/getRules'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setRules(result.text)
                })
                .catch(error => console.log('error', error))
    }, [])
    return (
            <Fade duration={200} left cascade>
                <div>
                    <div className="row justify-content-center">
                        <div className="Rules">
                            <ContentForm headetText="درباره ما">
                                <div className="RulesContent">
                                    <td dangerouslySetInnerHTML={{__html: rules}} />
                                </div>
                            </ContentForm>
                        </div>
                    </div>
                </div>
            </Fade>
            )
}

export default AboutUs